/*
From: https://reactrouter.com/web/guides/scroll-restoration
and 
https://stackoverflow.com/questions/31119786/window-scrollto-in-react-components
since only the App part is scrolling
*/

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.getElementById("scroller").scroll(0, 0);
  }, [pathname]);

  return null;
}
